import { useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

const links = [
  { id: "metodo", label: "Metodo" },
  { id: "bonus-excel", label: "Bonus Excel" },
  { id: "pacchetti", label: "Pacchetti" },
  { id: "faq", label: "FAQ" },
];

const LogoMark = () => (
  <img src="/logo.png" alt="Logo Disciplina" className="w-10 h-10 rounded-full ring-1 ring-white/10" />
);

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 150 : 0);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-ink-deep/85 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button data-testid="navbar-logo" onClick={() => go("top")} className="flex items-center gap-2.5">
          <LogoMark />
          <span className="font-display font-black text-2xl tracking-wide uppercase leading-none">
            Disciplina<span className="text-blood">Fit</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`navbar-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-300 hover:text-blood transition-colors"
            >
              {l.label}
            </button>
          ))}
          <motion.button
            data-testid="navbar-cta-btn"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => go("pacchetti")}
            className="bg-blood hover:bg-blood-hot text-white font-display font-bold uppercase tracking-wider text-lg leading-none px-6 py-2.5 red-glow transition-colors"
          >
            Inizia ora
          </motion.button>
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-ink-deep border-b border-white/10"
          >
            <div className="px-6 py-4 flex flex-col gap-4">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`navbar-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="font-mono text-sm uppercase tracking-[0.2em] text-neutral-200 text-left"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="navbar-mobile-cta"
                onClick={() => go("pacchetti")}
                className="bg-blood text-white font-display font-bold uppercase tracking-wider text-lg px-6 py-3 text-left"
              >
                Inizia ora
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
